import { useMemo } from 'react';

type UsePaginationProps = {
	skip: number;
	count: number;
	limitPerPage: number;
	onPageChange: (newSkip: number) => void;
};

export const usePagination = ({
	skip,
	count,
	limitPerPage,
	onPageChange
}: UsePaginationProps) => {
	const page = useMemo(
		() => (skip ? skip / limitPerPage + 1 : 1),
		[limitPerPage, skip]
	);

	const totalPages = useMemo(
		() => Math.ceil(count / limitPerPage),
		[count, limitPerPage]
	);

	const handleNextPage = () => {
		const nextSkip =
			skip + limitPerPage > count ? skip : skip + limitPerPage;
		onPageChange(nextSkip);
	};

	const handlePreviousPage = () => {
		const nextSkip = skip - limitPerPage < 0 ? skip : skip - limitPerPage;
		onPageChange(nextSkip);
	};

	const handleGotoPage = (targetPage: number) => {
		const pageToSkip = (targetPage - 1) * limitPerPage;
		const nextSkip =
			pageToSkip >= 0 && pageToSkip <= count ? pageToSkip : page;
		onPageChange(nextSkip);
	};

	return {
		page,
		totalPages,
		onNextPage: handleNextPage,
		onPreviousPage: handlePreviousPage,
		onGotoPage: handleGotoPage
	};
};
